// Deprecated. Please refrain from new usage
import PropTypes from "prop-types";
import React from "react";
import { withTheme } from "@material-ui/core/styles";
import CardHeader from "@material-ui/core/CardHeader";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import { withTranslation } from "react-i18next";
import useMediaQuery from "../../hooks/useMediaQuery";

const TopRight = (props) => {
  const style = {
    position: "absolute",
    top: 24,
    right: 24,
  };
  if (props.children) {
    return <div style={style}>{props.children}</div>;
  }
  return null;
};

TopRight.propTypes = {
  children: PropTypes.node,
};

TopRight.defaultProps = {
  children: null,
};

const CardHeaderWithTopRight = (props) => {
  const { cardHeaderProps, t } = props;

  const isMobile = useMediaQuery(props.theme.breakpoints.down("sm"));

  const style = {
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    padding: isMobile ? "4px 10px" : "4px 4px",
    textTransform: "capitalizeFirstWord",
  };
  return (
    <Grid style={style} container>
      <CardHeader
        title={t(props.title)}
        subheader={!isMobile && props.subheader}
        titleTypographyProps={{
          ...cardHeaderProps,
          variant: "h5",
        }}
      />
      {isMobile && props.subheader}
      {props.loading && (
        <TopRight>
          <CircularProgress />
        </TopRight>
      )}
      {!props.loading && <TopRight>{props.children}</TopRight>}
    </Grid>
  );
};

CardHeaderWithTopRight.propTypes = {
  cardHeaderProps: PropTypes.object,
  children: PropTypes.node,
  title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  t: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  subheader: PropTypes.node,
};

CardHeaderWithTopRight.defaultProps = {
  cardHeaderProps: null,
  children: null,
  title: null,
  loading: false,
  subheader: null,
};

export default withTranslation("common")(withTheme(CardHeaderWithTopRight));
export { CardHeaderWithTopRight, TopRight };
